import { BoardState } from '../lib/board';
import { GameMode } from '../lib/types';

const GAME_STORAGE_KEY = 'drop7_game';

type GameStorageData = BoardState | {
  [K in keyof BoardState]: null;
};

export const getGameStorage = (): GameStorageData => {
  const data = window.localStorage.getItem(GAME_STORAGE_KEY);
  if (data) {
    const parsed = JSON.parse(data) as GameStorageData;
    if (parsed.mode !== null &&
      parsed.rngState &&
      parsed.rngState.length === 4 &&
      parsed.cells &&
      parsed.level &&
      parsed.totalDrops &&
      parsed.dropsRemaining !== null &&
      parsed.currentDrop &&
      parsed.score !== null &&
      parsed.combo !== null &&
      parsed.gameOver !== null) {
      return parsed;
    }
  }
  return {
    mode: null,
    rngState: null,
    cells: null,
    level: null,
    totalDrops: null,
    dropsRemaining: null,
    currentDrop: null,
    score: null,
    combo: null,
    gameOver: null,
  };
};

export const setGameStorage = (data: GameStorageData | null) => {
  if (data && data.mode !== GameMode.Tutorial && !data.gameOver) {
    window.localStorage.setItem(GAME_STORAGE_KEY, JSON.stringify(data));
  } else {
    window.localStorage.removeItem(GAME_STORAGE_KEY);
  }
};
